import base from "./base.service";

const instance = base.service(); 

const checkStatus = async () => {
    try {
      const response = await instance.get("/auth/status", {
        withCredentials: true
      });
      return response.data; 
    } catch (error) {
      return null;
    }
  };
const login = async (credentials) => {
    const response = await instance.post("/auth/login", credentials, {
        withCredentials: true, 
    });
    return response.data; 
};

const logout = async () => {
    return instance.post("/auth/custom-logout", {}, {
        withCredentials: true
    });
};

export default {
    login,
    logout,
    checkStatus
};
